import styled from "styled-components";
import NavSideBar from "../../organisms/NavSideBar";
import UserToolBox from "../../organisms/UserToolBox";
import { Outlet } from "react-router-dom";
import "../../../../styles/scss/customize.scss";

const Wrap = styled.div`
    display: flex;
    min-width: 1200px;
`;
const BtnContainer = styled.div`
    display: flex;
    gap: 0 10px;
    justify-content: flex-end;

    button,
    a {
        min-width: 100px;
    }
`;

const Page = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    flex: 1 1;
    width: calc(100% - 250px);

    > .Loading {
        position: absolute;

        > div {
            height: 100vh;
        }
    }
`;

const PageHeader = styled.header`
    position: sticky;
    top: 0;
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: flex-end;
    padding: 0 50px;
    height: 60px;
    border-bottom: 1px solid rgba(231, 234, 243, 0.7);
    z-index: 99;
    background-color: #fff;
`;

const PageBody = styled.div`
    display: flex;
    flex-direction: column;
    padding: 20px 50px;
    flex: 1 1;
    gap: 1rem 0;

    &.detail {
        justify-content: space-between;
        margin-top: 30px;
    }

    .page-title {
        font-size: 22px;
        font-weight: 600;
        margin-bottom: 4px;
    }
`;

const PageTemplate = ({children, ...props}) => {
    return (
        <Wrap {...props}>
            <NavSideBar />

            <Page>
                <PageHeader>
                    <UserToolBox />
                </PageHeader>

                <PageBody>
                    <Outlet/>
                </PageBody>
            </Page>
        </Wrap>
    );
}


function Top({children, ...props}) {
    return (
        <div className="page-top" {...props}>
            {children}
        </div>
    );
}

function Content({children, ...props}) {
    return (
        <div className="content-wrap" {...props}>
            {children}
        </div>
    );
}

function ButtonContainer({children, ...props}) {
    return (
        <BtnContainer {...props}>
            {children}
        </BtnContainer>
    );
}
PageTemplate.Top = Top;
PageTemplate.Content = Content;
PageTemplate.ButtonContainer = ButtonContainer;
export default PageTemplate;